import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { AUTHORITIES_URLS } from '@mobi/rwc-utils-common-ng-jslib';

import { ImpersonationService } from '../impersonation.service';

const IGNORED_URLS = [...AUTHORITIES_URLS];

export const X_ON_BEHALF_OF_HEADER = 'x-on-behalf-of';

export const impersonationInterceptor: HttpInterceptorFn = (req, next) => {
    if (IGNORED_URLS.some(ignoredUrl => req.url.includes(ignoredUrl))) {
        return next(req);
    }

    const impersonationService = inject(ImpersonationService);
    const onBehalfOf = impersonationService.onBehalfOf;

    const requestWithImpersonation = onBehalfOf
        ? req.clone({
              setHeaders: {
                  [X_ON_BEHALF_OF_HEADER]: onBehalfOf
              }
          })
        : req;

    return next(requestWithImpersonation).pipe(
        tap(event => {
            if (event instanceof HttpResponse) {
                const responseOnBehalfOfHeader = event.headers.get(X_ON_BEHALF_OF_HEADER);
                const requestOnBehalfOfHeader = requestWithImpersonation.headers.get(X_ON_BEHALF_OF_HEADER);
                if (responseOnBehalfOfHeader && responseOnBehalfOfHeader !== requestOnBehalfOfHeader) {
                    impersonationService.switchUser(responseOnBehalfOfHeader);
                }
            }
        })
    );
};
